import { useState } from 'react';
import { Checkbox } from '@mui/material';
import ConfirmDialog from '../../../components/confirm-dialog';
import { Contact } from '../../../models/contact';
import { useSaveData } from '../../../hooks/useSaveData';
import { contactApiKeyStore } from '../../../api/contact-api-key-store';

interface CustomGridCellProps {
  field: string;
}

interface CellProps {
  contact: Contact;
}

const SendReportCell = ({ contact }: CellProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState<boolean | null>(null);

  const { isLoading, mutateAsync } = useSaveData<any>(contactApiKeyStore.enableSendReport(), () =>
    contactApiKeyStore.getContacts()
  );

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPendingValue(event.target.checked);
    setIsConfirmOpen(true);
  };

  const handleClose = () => {
    setIsConfirmOpen(false);
    setPendingValue(null);
  };

  const handleConfirm = () => {
    if (pendingValue === null) return;

    // mutateAsync({
    //   route: `/Contact/UpdateContactSendReport?contactsID=${contact.contactsID}&sendrporte=${pendingValue}`,
    // }).then(() => {
    //   handleClose();
    // });

    mutateAsync({
      data: {
        contactsID: contact.contactsID,
        sendrporte: pendingValue,
      },
    }).then(() => {
      handleClose();
    });
  };

  const confirmMessage =
    pendingValue === true
      ? `Are you sure you want to send report to ${contact.contactsFullName} ?`
      : `Are you sure you want to disable send  report  to ${contact.contactsFullName}?`;

  return (
    <td style={{ textAlign: 'center', padding: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Checkbox
          checked={!!contact.isSendReportEmail}
          onChange={handleCheckboxChange}
          inputProps={{ 'aria-label': 'Enable Email' }}
          sx={{ padding: '4px', margin: 0 }}
        />
      </div>
      <ConfirmDialog
        open={isConfirmOpen}
        title="CONFIRM UPDATE"
        message={confirmMessage}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isLoading}
      />
    </td>
  );
};

const FastFieldCell = ({ contact }: CellProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState<boolean | null>(null);

  const { isLoading, mutateAsync } = useSaveData<any>(contactApiKeyStore.enableFastField(), () =>
    contactApiKeyStore.getContacts()
  );

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPendingValue(event.target.checked);
    setIsConfirmOpen(true);
  };

  const handleClose = () => {
    setIsConfirmOpen(false);
    setPendingValue(null);
  };

  const handleConfirm = () => {
    if (pendingValue === null) return;

    // mutateAsync({
    //   route: `/Contact/UpdateFastFieldEmail?contactsID=${contact.contactsID}&fastFieldEmail=${pendingValue}`,
    // }).then(() => {
    //   handleClose();
    // });

    mutateAsync({
      data: {
        contactsID: contact.contactsID,
        fastFieldEmail: pendingValue,
      },
    }).then(() => {
      handleClose();
    });
  };

  const confirmMessage =
    pendingValue === true
      ? `Are you sure you want to send fast field to ${contact.contactsFullName} ?`
      : `Are you sure you want to disable send fast field to ${contact.contactsFullName}?`;

  return (
    <td style={{ textAlign: 'center', padding: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Checkbox
          checked={!!contact.sendReport}
          onChange={handleCheckboxChange}
          inputProps={{ 'aria-label': 'Enable Email' }}
          sx={{ padding: '4px', margin: 0 }}
        />
      </div>
      <ConfirmDialog
        open={isConfirmOpen}
        title="CONFIRM UPDATE"
        message={confirmMessage}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isLoading}
      />
    </td>
  );
};

export const CustomGridCell = ({ field }: CustomGridCellProps) => {
  if (field === 'isSendReportEmail') {
    return (dataItem: any) => {
      return <SendReportCell contact={dataItem.dataItem} />;
    };
  }
  if (field === 'sendReport') {
    return (dataItem: any) => {
      return <FastFieldCell contact={dataItem.dataItem} />;
    };
  }
};
